<template>
  <ul :class="style['action-container']">
    <li v-if="slide.detail" :class="style.action">
      <a v-theme-font @click="showDetailsPage">{{ $t('details_page.details') }}</a>
    </li>
    <li v-for="(action, index) in slide.actions" :key="index" :class="style.action">
      <a
        v-if="action.url"
        v-theme-font
        :href="action.url"
        target="_blank"
        :class="style.external"
        >{{ action.text }}</a
      >
      <button
        v-if="!action.url"
        v-theme="!!action.reply"
        :class="style['btn-action']"
        type="button"
        @click="sendReply(action)"
      >
        {{ action.text }}
      </button>
    </li>
  </ul>
</template>

<script>
import style from './scss/_slider.scss'
import { useDetailsPageStore } from 'Store/details-page'

export default {
  setup() {
    return {
      detailsPageStore: useDetailsPageStore()
    }
  },
  props: {
    slide: { type: Object, required: true },
    chat: { type: Object }
  },
  computed: {
    style: () => style
  },
  methods: {
    showDetailsPage(slide) {
      this.detailsPageStore.setSlideContent(this.slide)
      this.detailsPageStore.setPageChat(this.chat)
      this.detailsPageStore.setDetailsPageShown('SliderDetails')
    },
    sendReply(action) {
      this.$emit('sendReply', action)
    }
  }
}
</script>
